import { render, staticRenderFns } from "./NumericStatus.vue?vue&type=template&id=5c5b832c&scoped=true&"
import script from "./NumericStatus.vue?vue&type=script&lang=js&"
export * from "./NumericStatus.vue?vue&type=script&lang=js&"
import style0 from "./assets/scss/widget-colors.scss?vue&type=style&index=0&id=5c5b832c&scoped=true&lang=scss&"
import style1 from "./NumericStatus.vue?vue&type=style&index=1&id=5c5b832c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5b832c",
  null
  
)

export default component.exports